/* eslint-disable no-console */

import {EventEmitter, Listener} from "events";
import env from "@/services/env";

export let openRequestCounter = 0;
export const logBus = new EventEmitter();

const logBusInDev = (type: string | number, listener: Listener) => {
  if (!env.isProduction()) {
    logBus.on("COMM", listener);
  }
};

// @todo all logging should depend on environment (and no display in production)
logBusInDev("COMM", (ev, opt = null) => {
// tslint:disable-next-line:no-console
  console.log("COMM", ev, opt);
  switch (("" + ev).substr(0, 6)) {
    case "START:":
      openRequestCounter++;
      if (openRequestCounter > 100) {
        logBus.emit("ERROR", "start-type: this does not work fine", opt);
      }
      break;
    case "200OK:":
    case "ERROR:":
      openRequestCounter--;
      if (openRequestCounter < 0) {
        logBus.emit("ERROR", "this does not work well", opt);
      }
  }
});

logBusInDev("ERROR", (ev, opt = null) => {
// tslint:disable-next-line:no-console
  console.log("ERROR", ev, opt); // Test
});

export const auxLog = (e: string) => {
  // tslint:disable-next-line:no-console
  console.log(e);
};
